import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import {
  UserImportDataSource,
  UserImportDataSourceIdentifier,
  UserImportSourceType
} from '@dadohr/shared/domainTypes/user';
import { FS } from '@dadohr/shared/versions';
import { Tooltip } from '@material-ui/core';
import { store } from '../../../../../services/firebase';
import {
  createDocumentListenerGetter,
  useDocumentListener
} from '../../../../../services/firecache/documentListener';
import { ImportSourceChip } from './ImportSourceChip';
import { IMPORT_META, MergeHRISIntegrationsInfoMap } from './sources/meta';

const mergeInfos = Object.values(MergeHRISIntegrationsInfoMap);

export const ImportSourceLogo = ({
  identifier
}: {
  identifier: UserImportDataSourceIdentifier;
}) => {
  const type = identifier.type;
  if (type === UserImportSourceType.MANUAL_CSV) {
    return null;
  }

  const meta =
    type === UserImportSourceType.AIRTABLE
      ? IMPORT_META.AIRTABLE
      : type === UserImportSourceType.BAMBOO_HR
      ? IMPORT_META.BAMBOOHR
      : type === UserImportSourceType.BOB
      ? IMPORT_META.BOB
      : type === UserImportSourceType.CHARTHOP
      ? IMPORT_META.CHARTHOP
      : type === UserImportSourceType.GOOGLE_SHEET
      ? IMPORT_META.GOOGLE
      : type === UserImportSourceType.GREENHOUSE_V3
      ? IMPORT_META.GREENHOUSE_V3
      : type === UserImportSourceType.PERSONIO
      ? IMPORT_META.PERSONIO
      : type === UserImportSourceType.PINGBOARD
      ? IMPORT_META.PINGBOARD
      : type === UserImportSourceType.WORKDAY_REPORT_API
      ? IMPORT_META.WORKDAY
      : type === UserImportSourceType.MS_EXCEL
      ? IMPORT_META.EXCEL
      : type === UserImportSourceType.ADP_WORKFORCE_NOW
      ? IMPORT_META.ADP_WORKFORCE_NOW
      : type === UserImportSourceType.ASHBY
      ? IMPORT_META.ASHBY
      : type === UserImportSourceType.SFTP
      ? IMPORT_META.SFTP
      : type === UserImportSourceType.EMAIL_CSV
      ? IMPORT_META.EMAIL_CSV
      : type === UserImportSourceType.SALESFORCE
      ? IMPORT_META.SALESFORCE
      : type === UserImportSourceType.UKG
      ? IMPORT_META.UKG
      : null;

  if (meta) {
    const inactive = identifier.isInactive ? {opacity: 0.5} : {},
        tooltipTitle = identifier.isInactive ? `${meta.name} (inactive)` : meta.name;

    return (
      <Tooltip title={tooltipTitle}>
        <img src={meta.smallLogoUrl} height={16} alt={tooltipTitle} style={inactive} />
      </Tooltip>
    );
  } else if (type === UserImportSourceType.MERGE_HRIS) {
    return (
      <MergeImportSourceLogo identifier={identifier}></MergeImportSourceLogo>
    );
  } else {
    return <ImportSourceChip size="small" identifier={identifier} />;
  }
};

const toImportDataSourceDoc = generateToDocFn<UserImportDataSource>();

export const userImportDataSourceStore = createDocumentListenerGetter(
  (id) => store().collection(FS.userImportDataSources).doc(id),
  toImportDataSourceDoc
);

const MergeImportSourceLogo = ({
  identifier
}: {
  identifier: UserImportDataSourceIdentifier;
}) => {
  const [userImportDataSource] = useDocumentListener(
    userImportDataSourceStore(identifier.id)
  );

  const meta = mergeInfos.find((m) => {
    if (userImportDataSource?.data.type === UserImportSourceType.MERGE_HRIS) {
      return m.mergeHRIS === userImportDataSource?.data.hris;
    }
    return false;
  });
  if (!meta) {
    return null;
  }

  const inactive = identifier.isInactive ? {opacity: 0.5} : {},
        tooltipTitle = identifier.isInactive ? `${meta.name} (inactive)` : meta.name;

  return (
    <Tooltip title={tooltipTitle}>
      <img src={meta.smallLogoUrl} height={16} alt={tooltipTitle} style={inactive} />
    </Tooltip>
  );
};
